import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {DateAdapter, ErrorStateMatcher, MAT_DATE_LOCALE} from '@angular/material/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-youtube-dialog',
  templateUrl: './youtube-dialog.component.html',
  styleUrls: [ './youtube-dialog.component.scss' ]
})

export class YoutubeDialogComponent implements OnInit, OnDestroy {

  public Editor = ClassicEditor

  public matcher = new FormErrorStateMatcher(); // 
  public entityForm: FormGroup;
  public isEdit: boolean = false;

  // Variáveis para upload
  selectedFile: File | null = null;
  selectedFileName: any | null = null;
  storedImage: any | null = null;

  public image_path: string;

  constructor (
    public matDialogRef: MatDialogRef<YoutubeDialogComponent>,
    private fb: FormBuilder,
    private _adapter: DateAdapter<any>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // console.log("dialog data: " + JSON.stringify(this.data));
    this.entityForm = this.createForm(this.data)
    this.isEdit = this.data.id !== '0';
  }

  ngOnInit () {
    this._adapter.setLocale('pt');
  }

  ngOnDestroy () { }

  createForm (data: any) {
    let form: FormGroup = this.fb.group({
      id: new FormControl(data.id),
      src: new FormControl(data.src),
      file: new FormControl(data.file, [ Validators.required ]),
      title: new FormControl(data.title, [ Validators.required ]),
      author: new FormControl(data.author, [ Validators.required ]),
      text: new FormControl(data.text),
      youtube: new FormControl(data.youtube, [ Validators.required ]),
      date: new FormControl(data.date?.toDate() || null, [ Validators.required ]),
      dateIn: new FormControl(data.dateIn?.toDate() || null, [ Validators.required ]),
      dateOut: new FormControl(data.dateOut?.toDate() || null, [ Validators.required ]),
    });

    this.selectedFileName = data.file;
    this.storedImage = data.src;

    return form
  }

  onFileSelected (event: any): void {
    const file: File = event.target.files[ 0 ];
    if (file) {
      this.selectedFile = file;
      this.entityForm.controls.file.setValue(file.name);
      this.previewImage(this.selectedFile)
    }
  }

  previewImage (selectedFile: any) {

    var reader = new FileReader();
    reader.readAsDataURL(selectedFile);
    reader.onload = (_event) => {
      this.storedImage = reader.result;
    }
  }


}

